// import FeatureProduct from "./components/FeatureProduct";
// import HeroSection from "./components/HeroSection";
import FilterSection from "./components/FilterSection";
import Sort from "./components/Sort";
import ProductList from "./components/ProductList";
import styled from "styled-components";
// import Services from "./components/Services";
// import Trusted from "./components/Trusted";

// const Home = () => {
//   const data = {
//     name: "SixthSens AI MarketPlace",
//   };
//
//   return (
//     <>
//       <HeroSection myData={data} />
//       <FeatureProduct />
//       {/*<Services />*/}
//       {/*<Trusted />*/}
//     </>
//   );
// };
//
// export default Home;

const Home = () => {
  return (
    <Wrapper>
      <div className="container grid grid-filter-column">
        <div>
          <FilterSection />
        </div>

        <section className="product-view--sort">
          <div className="sort-filter">
            <Sort />
          </div>
          <div className="main-product">
            <ProductList />
          </div>
        </section>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .grid-filter-column {
    grid-template-columns: 0.2fr 1fr;
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .grid-filter-column {
      grid-template-columns: 1fr;
    }
  }
`;

export default Home;